import { ACTION_TYPES } from './store/action';
import { sellingPointApiInstance } from '../api';
import { IUserInfo } from 'app/modules/contract/model/userInfo.model';
import { ISellingPointInfoBanking } from '../model/selling-point.model';

// récuperer les dossiers liés a une adhésions
export const getClaimsSubscriptionByNumber = (clientNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CONNECTED_SELLING_POINT,
    payload: sellingPointApiInstance.getSellingPointSubscriber(clientNumber),
  });
};

export const updateSellingPointSebscriber = (userInfo: IUserInfo) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.UPDATE_CONNECTED_SELLING_POINT,
    payload: sellingPointApiInstance.updateSellingPointSubscriber(userInfo),
  });
};
export const updateSellingPointInfoBank = (sellingPointInfoBanking: ISellingPointInfoBanking) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.UPDATE_SELLING_POINT_INFO_BANK,
    payload: sellingPointApiInstance.updateSellingPointInfoBank(sellingPointInfoBanking),
  });
};

export const cleanUpdatedSellingPoint = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.CLEAN_UPDATED_SELLING_POINT_BANK,
    payload: {},
  });
};

export const sellectSellingPoint = (sellingPoint: any) => async dispatch => {
  sessionStorage.setItem('connectedSellingPoint', JSON.stringify(sellingPoint));

  await dispatch({
    type: ACTION_TYPES.SELECT_SELLING_POINT,
    payload: sellingPoint,
  });
};

export const getSellingPoint = () => async (dispatch, getState) => {
  const { connectedSellingPoint } = await getState().sellingPoint;

  await dispatch({
    type: ACTION_TYPES.GET_SELLING_POINT,
    payload: sellingPointApiInstance.getSellingPoint(),
  });
};
